module.exports = __webpack_public_path__ + "img/box1.84119db7.png";